import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
export function SkipNav() {
  const $ = _c(4);
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = t("layout.skip-to-main-content");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <a href="#main-content" className="fixed left-4 z-50 -translate-y-20 rounded-4xl border bg-background px-3 py-2 font-medium transition-transform focus:outline-none focus-visible:translate-y-0 focus-visible:ring-3 focus-visible:ring-ring focus-visible:ring-offset-2">{t0}</a>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}